import type { CourseWithContent, ModuleWithContent } from '@/shared/api/hooks/useCourses';

export function filterPublishedModules(modules: ModuleWithContent[]): ModuleWithContent[] {
  return modules
    .map((module) => ({
      ...module,
      topics: (module.topics ?? [])
        .map((topic) => ({
          ...topic,
          lessons: (topic.lessons ?? []).filter((lesson) => lesson.isLive === true),
        }))
        .filter((topic) => (topic.lessons?.length ?? 0) > 0),
    }))
    .filter((module) => (module.topics?.length ?? 0) > 0);
}

export function getPublishedCourseModules(
  course: Pick<CourseWithContent, 'modules'> | null | undefined
) {
  return filterPublishedModules(course?.modules ?? []);
}

export function countPublishedLessons(modules: ModuleWithContent[]): number {
  return modules.reduce(
    (total, module) =>
      total +
      (module.topics ?? []).reduce(
        (topicTotal, topic) => topicTotal + (topic.lessons?.length ?? 0),
        0
      ),
    0
  );
}

export function countPublishedTopics(modules: ModuleWithContent[]): number {
  return modules.reduce((total, module) => total + (module.topics?.length ?? 0), 0);
}

export function estimateCourseTime(lessonCount: number): string {
  const totalMinutes = lessonCount * 5;
  if (totalMinutes < 60) return `~${totalMinutes} min`;
  const hours = Math.floor(totalMinutes / 60);
  const mins = totalMinutes % 60;
  if (mins === 0) return `~${hours}h`;
  return `~${hours}h ${mins}m`;
}
